module.exports = __webpack_public_path__ + "static/media/resultats_sapin2021.19365c0f.jpg";